import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0ea0a634"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "options-body" }
const _hoisted_2 = { class: "option" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Players", -1))
const _hoisted_4 = ["value"]
const _hoisted_5 = { class: "option" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Scenario Text", -1))
const _hoisted_7 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["options-panel", { collapsed: !_ctx.isOpen }])
  }, [
    _createElementVNode("button", {
      class: "options-toggle",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isOpen = !_ctx.isOpen))
    }, _toDisplayString(_ctx.isOpen ? 'Hide' : 'Options'), 1),
    _withDirectives(_createElementVNode("div", _hoisted_1, [
      _createElementVNode("label", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("input", {
          type: "number",
          value: _ctx.playerCount,
          min: "0",
          max: "100",
          onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:playerCount', Number(($event.target as HTMLInputElement).value))))
        }, null, 40, _hoisted_4)
      ]),
      _createElementVNode("label", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("textarea", {
          value: _ctx.scenarioText,
          rows: "4",
          onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('update:scenarioText', ($event.target as HTMLInputElement).value)))
        }, null, 40, _hoisted_7)
      ])
    ], 512), [
      [_vShow, _ctx.isOpen]
    ])
  ], 2))
}